// components/CitySelect.tsx
import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import axios from 'axios';
import { DEFAULT_CROP_YEAR_ID } from 'Common/constants/cropYear';

interface City {
  id: number;
  city: string;
}

interface CitySelectProps {
  selectedCity: any;
  onCityChange: (city: any) => void;
  label: string;
  placeholder: string;
  cropyearID?: number;
}

const CitySelect: React.FC<CitySelectProps> = ({
  selectedCity,
  onCityChange,
  label,
  placeholder,
  cropyearID = DEFAULT_CROP_YEAR_ID
}) => {
  const [citiesList, setCitiesList] = useState<City[]>([]);
  const [searchInput, setSearchInput] = useState<string>('');

  useEffect(() => {
    const fetchCities = async () => {
      try {
        let url = `https://api.havirkesht.ir/city/?crop_year_id=${cropyearID}&sort_by=updated_at&sort_order=desc`;
        if (searchInput) {
          url += `&search=${encodeURIComponent(searchInput)}`;
        }
        
        const response = await axios.get(url, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('app_atkey')}`
          }
        });
        
        setCitiesList(response.data?.items || []);
      } catch (error) {
        console.error('Error fetching cities data:', error);
      }
    };

    fetchCities();
  }, [searchInput, cropyearID]);

  const handleChange = (selectedOption: any) => {
    onCityChange(selectedOption?.data || null);
  };

  const cityOptions = citiesList.map((city) => ({
    value: city.id,
    label: city.city,
    data: city
  }));

  const selectedValue = selectedCity
    ? {
        value: selectedCity.id,
        label: selectedCity.city,
        data: selectedCity
      }
    : null;

  return (
    <div className="flex flex-col">
      <label className="text-base font-medium mb-2 dark:text-white">
        {label}:
      </label>
      
      <Select
        options={cityOptions}
        value={selectedValue}
        onChange={handleChange}
        onInputChange={setSearchInput}
        styles={{
          control: (base, state) => ({
            ...base,
            minHeight: '44px',
            borderColor: state.isFocused ? '#4CAF50' : '#ddd',
            boxShadow: state.isFocused ? '0 0 0 1px #4CAF50' : 'none',
            '&:hover': {
              borderColor: state.isFocused ? '#4CAF50' : '#ccc'
            }
          }),
          menuPortal: (base) => ({ ...base, zIndex: 9999 })
        }}
        menuPortalTarget={document.body}
        placeholder={placeholder}
        noOptionsMessage={() => 'شهری با این مشخصات یافت نشد'}
        loadingMessage={() => 'در حال بارگذاری...'}
        className="w-full my-react-select-container"
        classNamePrefix="my-react-select"
        maxMenuHeight={300}
        isClearable={true}
        isSearchable={true}
        closeMenuOnSelect={true}
      />
    </div>
  );
};

export default CitySelect;